// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__MiK3W","columns":"App_columns__2rkqN","sidebar":"App_sidebar__I2vvX","main":"App_main__kWSe7"};